import type Theme from "../types/Theme";

const useTheme = (): Theme => {
	const params = new URLSearchParams(window.location.search);

	return params.get("theme") === "dark" ? "dark" : "light";
};

export default useTheme;
